// extracted by mini-css-extract-plugin
export default {"page":"CenteredPage_page__llovs","header":"CenteredPage_header__+S+Fs","footer":"CenteredPage_footer__CUXGM","main":"CenteredPage_main__WGm++"};